import React from 'react';
import { useAppUpdate, UPDATE_STATE } from '../utils/appUpdate';

/**
 * VersionCard — "what am I running, and is it the latest?" on My Profile
 * (desktop and phone both show this one card). The top bar prints the version
 * too, but a number on its own cannot say whether it is old; this card asks the
 * Play Store and says so in words.
 *
 * On ANDROID the Play Store hands back only the versionCode of the newer build
 * (`availableVersionName` is iOS-only), so a waiting update reads
 * "Play Store build 29" against the installed "3.5.1 (28)" — never an invented
 * version name.
 *
 * In a browser, and on a sideloaded APK or offline (where in-app updates cannot
 * answer), the state is UNKNOWN: the installed version is still printed, and we
 * say we could not check rather than calling the build old.
 */
export default function VersionCard() {
  const { installed, state, availableCode, installedCode, isWeb, checking, check, openPlayStore } = useAppUpdate();

  const line = {
    [UPDATE_STATE.LATEST]: { cls: 'ok', text: '✓ You are on the latest version' },
    [UPDATE_STATE.UPDATE]: { cls: 'old', text: '⬆ A newer version is on the Play Store' },
    [UPDATE_STATE.UNKNOWN]: {
      cls: 'unknown',
      text: isWeb
        ? 'Web app — it reloads to the latest on its own'
        : 'Could not check the Play Store just now',
    },
  }[state];

  return (
    <div className="card card-pad vc-card">
      <div className="step-label">App version</div>

      <div className="vc-now">{installed}</div>
      <div className={`vc-state vc-${line.cls}`}>{line.text}</div>

      {state === UPDATE_STATE.UPDATE && !!availableCode && (
        <div className="vc-rows">
          <div><span className="muted">Installed build</span><b>{installedCode || '—'}</b></div>
          <div><span className="muted">Play Store build</span><b>{availableCode}</b></div>
        </div>
      )}

      <div className="vc-actions">
        {!isWeb && (
          <button type="button" className="btn light sm" disabled={checking} onClick={check}>
            {checking ? 'Checking…' : 'Check for update'}
          </button>
        )}
        {state === UPDATE_STATE.UPDATE && (
          <button type="button" className="btn primary sm" onClick={openPlayStore}>Update now</button>
        )}
      </div>
    </div>
  );
}
